"use strict";
var nav = document.querySelector(".nav");
var open = document.querySelector(".header__menu--open");
var close = document.querySelector(".header__menu--close");
open.addEventListener("click", function() {
    nav.classList.toggle("nav--active");
    document.body.classList.add("page__body--with-menu");
});
close.addEventListener("click", function() {
    nav.classList.remove("nav--active");
    document.body.classList.remove("page__body--with-menu");
});
document.querySelectorAll(".nav__link").forEach(function(n) {
    n.addEventListener("click", function() {
        nav.classList.remove("nav--active");
        document.body.classList.remove("page__body--with-menu");
    });
});
document.querySelectorAll(".logo").forEach(function(n) {
    n.addEventListener("click", function() {
        nav.classList.remove("nav--active");
        document.body.classList.remove("page__body--with-menu");
    });
});

//# sourceMappingURL=index.21d33803.js.map
